/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFolderPin = createReactComponent("folder-pin", "IconFolderPin", [
  [
    "path",
    {
      d: "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 18v.01", key: "svg-2" }]
]);

export { IconFolderPin as default };
//# sourceMappingURL=IconFolderPin.js.map
